import { render } from "./TrainerPreview.vue?vue&type=template&id=383af15a"
import script from "./TrainerPreview.vue?vue&type=script&lang=js"
export * from "./TrainerPreview.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__